import React from "react";

import { useTranslation, Trans } from "react-i18next";

import a1 from '../../img/Home/a1.webp';
import a2 from '../../img/Home/a2.webp';
import a3 from '../../img/Home/a3.webp';
import a4 from '../../img/Home/a4.webp';
import a5 from '../../img/Home/a5.webp';
import a6 from '../../img/Home/a6.webp';
import a7 from '../../img/Home/a7.webp';
import a8 from '../../img/Home/a8.webp';
import a9 from '../../img/Home/a9.webp';
import a10 from '../../img/Home/a10.webp';
import a11 from '../../img/Home/a11.webp';
import a12 from '../../img/Home/a12.webp';

function Areas () {

    const { t } = useTranslation();

    const data = [
        {
            title: t('home.41'),
            img: a1
        },
        {
            title: t('home.42'),
            img: a2
        },
        {
            title: t('home.43'),
            img: a3
        },
        {
            title: t('home.44'),
            img: a4
        },
        {
            title: t('home.45'),
            img: a5
        },
        {
            title: t('home.46'),
            img: a6
        },
        {
            title: t('home.47'),
            img: a7
        },
        {
            title: t('home.48'),
            img: a8
        },
        {
            title: t('home.49'),
            img: a9
        },
        {
            title: t('home.50'),
            img: a10
        }, 
        {
            title: t('home.51'),
            img: a11
        },   
        {
            title: t('home.52'),
            img: a12
        },     
    ]
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center xl:max-w-[489.563px] leading-[1.4]"><Trans>{t('home.40')}</Trans></p>
                </div>
                <div className="xl:flex flex-wrap mt-[35px] xl:mt-[90px] hidden">
                    {data.map((item, index) =>(
                        <div key={index} className="w-[300px] h-[129px] group flex items-center justify-center cursor-pointer">
                            <p className="open-sans text-[16px] text-[#F26522] text-center group-hover:opacity-0 opacity-100 transition-all duration-1000"><Trans>{item.title}</Trans></p>
                            <img src={item.img} alt="" className="opacity-0 group-hover:opacity-100 absolute transition-all duration-1000"/>
                        </div>
                    ))}
                </div>
                <div className="mt-[35px] flex flex-col sm:items-center xl:hidden gap-y-[15px]">
                    {data.map((item, index) => {
                        const cleanTitle = item.title.replace(/<br\s*\/?>/gi, ' ');
                        return (
                        <div key={index}>
                            <p className="open-sans text-[15px] font-[300] text-[#F26522]">· {cleanTitle}</p>
                        </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Areas;